<template>
  <div :class="{ 'remote-job': true, 'is-loading': !allDataLoaded }">
    <h4 class="mb-3 pb-3 d-flex border-bottom">
      <span>Praca zdalna</span>
    </h4>

    <remote-job-product
      v-for="(product, index) of data.products"
      :key="'product-' + index"
      :ref="'order-product-' + index"
      :orderID="orderID"
      :productData="product"
      :productIndex="index"
      :products="products"
      :procedures="procedures"
      :colors="colors"
      :seams="seams"
      :materials="materials"
      :strands="strands"
      :polars="polars"
      :sizes="sizes"
      :workers="workers"
      :remoteJobs="jobItems"
      :canEdit="canEdit" />
  </div>
</template>

<script>
import debounce from 'lodash.debounce';
import FormUtils from './../../../utils/FormUtils.js';
import RemoteJobProduct from './RemoteJobProduct.vue';
import Vue from 'vue';

export default {
  name: 'remote-job',
  props: [
    'orderID',
    'products',
    'procedures',
    'colors',
    'seams',
    'materials',
    'strands',
    'polars',
    'sizes',
    'workers',
    'drivers',
    'canEdit'
  ],
  components: {
    'remote-job-product': RemoteJobProduct
  },
  watch: {
    'data.products': {
      handler() {
        this.$bus.$emit('remote-job-products-updated');
      },
      deep: true
    }
  },
  computed: {
    allDataLoaded () {
      return this.formDataLoaded && this.loadedItems;
    }
  },
  data () {
    return {
      formDataLoaded: false,
      loadedItems: false,
      loadError: false,
      jobItems: [],
      data: {
        products: []
      }
    }
  },
  mounted () {
    this.loadData();
    this.$bus.$on('order-form-all-data-loaded-status', this.setFormDataLoaded);
    this.$bus.$on('order-reload-remote-jobs', this.debouncedLoadData);
  },
  methods: {
    debouncedLoadData: debounce(function () {
      this.loadData();
    }, 500),
    loadData () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/orders/remote-jobs/items',
        outputKey: 'jobItems',
        loadedKey: 'loadedItems',
        errorKey: 'loadError',
        params: {
          where: {
            order_id: this.orderID
          }
        },
        successAction: () => {
          this.$bus.$emit('order-product-updated-remote-jobs', this.jobItems);
        }
      });
    },
    setFormDataLoaded (newValue) {
      Vue.set(this, 'formDataLoaded', newValue);
    },
    setUpProducts (products) {
      this.data.products = JSON.parse(JSON.stringify(products));
    }
  },
  beforeDestroy () {
    this.$bus.$off('order-form-all-data-loaded-status', this.setFormDataLoaded);
    this.$bus.$off('order-reload-remote-jobs', this.debouncedLoadData);
  }
}
</script>

<style lang="scss" scoped>
.remote-job.is-loading {
  opacity: .25;
  pointer-events: none;
}
</style>
